import { SAVE_WORKFLOWS } from '~/client/src/shared/stores/EventStore/eventConstants'
import BaseActionBarStore from '~/client/src/shared/stores/ui/BaseActionBar.store'

import Message from '../models/Message'
import Workflow from '../models/Workflow'
import MessageDto from '../types/MessageDto'

export default class PermitLogActionBarStore extends BaseActionBarStore {
  protected updateThreadEntity(threadEntity: Workflow) {
    const message = threadEntity.isChanged ? this.draftMessage : null
    this.eventsStore.dispatch(SAVE_WORKFLOWS, [threadEntity], message)
  }

  protected saveMessage(
    threadEntityId: string,
    message: Message,
  ): Promise<MessageDto> {
    return this.messagesStore.saveWorkflowMessage(threadEntityId, message)
  }
}
